import React, { useEffect, useState } from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './CompaniesModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'
import DummyCounter from 'components/ContentBox/Global/Counter/DummyCounter'

export const MarkType = {
  SIMPLE: 1,
  FIVE_INTEGERS: 2,
  TEN_INTEGERS: 3,
  GRADES: 4,
}

export const markTypeOptions = [
  { id: MarkType.SIMPLE, label: 'Простое оценивание (по умолчанию)' },
  { id: MarkType.FIVE_INTEGERS, label: 'Оценивание по пятибальной шкале' },
  { id: MarkType.TEN_INTEGERS, label: 'Оценивание по десятибальной шкале' },
  { id: MarkType.GRADES, label: 'Оценивание по грейдам' },
]

const CompaniesModal = () => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore
  const [num, setNum] = useState(0)

  useEffect(() => {
    changeValue(
      num.length > 0 ? Number(num.replace(/\s/g, '')) * 100 : 0,
      'fixed_price',
    )
  }, [num])

  return (
    <div className={st.fieldSet}>
      <div className={st.fieldLine}>
        <FormField>
          <FormLabel isRequired>Имя:</FormLabel>
          <FormInput isError={check('name')}>
            <input
              type='text'
              placeholder='Имя'
              name='name'
              maxLength={35}
              value={modalValue.name}
              onChange={(e) => changeValue(e.target.value, 'name')}
            />
          </FormInput>
        </FormField>

        <FormField>
          <FormLabel isRequired>Валюта:</FormLabel>
          <FormInput isError={check('currency')}>
            <SelectCustom
              placeholder='Валюта'
              apiLink='db/companies'
              apiConfParams={{ currency: true }}
              error={check('currency')}
              valueID={modalValue.currency}
              optionLabelKey='full_name'
              onChange={(o) => changeValue(o.id, 'currency')}
              apiGetResult={(val) =>
                val.map((el) => ({
                  ...el,
                  full_name: `${el.name} (${el.short_name} ${el.sign})`,
                }))
              }
            />
          </FormInput>
        </FormField>
      </div>

      <div className={st.fieldLineBeetween}>
        <ToggleCheckbox
          label='Cashback'
          checked={modalValue.active_cashback}
          onChange={() => {
            changeValue(!modalValue.active_cashback, 'active_cashback')
            changeValue(0, 'percent')
          }}
        />

        {modalValue.active_cashback && (
          <div className={st.counter}>
            <DummyCounter
              value={+modalValue.percent || 0}
              min={0}
              max={100.5}
              name='percent'
              step={0.5}
              onChange={(e) =>
                modalValue.active_cashback && changeValue(e, 'percent')
              }
            />
          </div>
        )}
      </div>

      {modalValue.active_cashback && (
        <div className={st.fieldLineBeetween}>
          <div className={st.fieldLineText}>Период активации в днях</div>
          <div className={st.counter}>
            <DummyCounter
              value={modalValue.block_period || 0}
              min={0}
              max={30}
              name='block_period'
              step={1}
              onChange={(e) => changeValue(e, 'block_period')}
            />
          </div>
        </div>
      )}

      <div className={st.line}></div>

      <div className={st.fieldLine}>
        <FormField>
          <FormLabel>Сумма для первого уведомления:</FormLabel>
          <FormInput>
            <input
              placeholder='Amount'
              type='text'
              min='0'
              value={String(modalValue.sum1 || '')}
              onChange={(e) =>
                changeValue(+e.target.value.replace(/\D/g, ''), 'sum1')
              }
            />
          </FormInput>
        </FormField>

        <FormField>
          <FormLabel>Сумма для второго уведомления:</FormLabel>
          <FormInput>
            <input
              placeholder='Amount'
              type='text'
              min='0'
              value={String(modalValue.sum2 || '')}
              onChange={(e) =>
                changeValue(+e.target.value.replace(/\D/g, ''), 'sum2')
              }
            />
          </FormInput>
        </FormField>
      </div>

      <div className={st.fieldLineBeetween}>
        <div className={st.fieldLineText}>Количество уроков:</div>
        <div className={st.counter}>
          <DummyCounter
            value={modalValue.amount_lesson || 0}
            min={0}
            name='amount_lesson'
            step={1}
            onChange={(e) => changeValue(+e, 'amount_lesson')}
          />
        </div>
      </div>

      <div className={st.line}></div>

      <ToggleCheckbox
        label='Отправка уведомлений на Email'
        checked={modalValue.email}
        onChange={() => changeValue(!modalValue.email, 'email')}
      />

      <ToggleCheckbox
        label='Отправка уведомлений на Whatsapp'
        checked={modalValue.wazzap}
        onChange={() => changeValue(!modalValue.wazzap, 'wazzap')}
      />

      <FormField>
        <FormLabel>Тип оценивания:</FormLabel>
        <FormInput isError={check('mark_type')}>
          <SelectCustom
            placeholder='Выберите тип'
            valueID={modalValue.mark_type}
            options={markTypeOptions}
            onChange={(option) => changeValue(option.id, 'mark_type')}
          />
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel isRequired>Комментарий:</FormLabel>
        <FormInput isError={check('comment')}>
          <textarea
            placeholder='Комментарий'
            value={modalValue.comment}
            onChange={(e) => changeValue(e.target.value, 'comment')}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(CompaniesModal)
